import EditUser from './EditUser';
import {ActionCreators} from '../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, getClient, getLocation} from '../../reducers/rootReducer';

const mapStateToProps = state => {
  const {user, users, addingUser, addedUser, updatedUser, updatingUser, lastUser} = getUser(state);
  const {clients} = getClient(state);
  const {locations} = getLocation(state);

  return {
    user,
    users,
    addingUser,
    addedUser,
    updatedUser,
    updatingUser, 
    lastUser,
    clients,
    locations
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditUser);
